import React, { Fragment } from "react";
import axios from "axios";
import { domain } from "../../utils/util";
// import Loader from "components/Common/Loader.jsx";
import qs from "qs";
import { hist } from "../..";

export class DashBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      iframeData: null,
      iframeUrl: null,
      loading: false,
    };
  }

  componentDidMount = () => {
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    if (data && data.token) {
      const config = {
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      };

      axios
        .get(`${domain}/user/get/iframe/url`, config)

        .then((res) => {
          // console.log("I", config, res);
          if (res.data.statusCode === 200 || res.data.statusCode === 201) {
            //  console.log("iiiiiiiiiiiiiiiiiiiiiiiiiiiiii", res.data.data);
            this.setState({
              iframeData: res.data.data,
              //loading: true,
            });
          }

          if (res.data.statusCode === 401) {
            window.localStorage.clear();
            window.location.reload();
          }
        })
        .catch((error) => {});
    }
  };

  iframeLoad = () => {
    //console.log("llll.................................")
    this.setState({ loading: true });
  };

  render() {
    const { iframeUrl } = this.state;
    return (
      <Fragment>
        {!this.state.loading && (
          <div className="loaderContainer">
            <p className="loader"></p>
          </div>
        )}

        <div className="game_wrapper">
          {/* <iframe
          //src={this.state.iframeData && this.state.iframeData.url}
          src=""
          frameborder="0"
          width="100%"
          allowtransparency
          onLoad={this.iframeLoad}
        ></iframe> */}
          <iframe
            src={this.state.iframeData && this.state.iframeData.url}
            // src="https://analytics.affleprojects.com/public/dashboard/3ff6553d-b86a-4b64-88c6-a259310b17e7"
            frameBorder="0"
            width="100%"
            height="100%"
            allowtransparency="true"
            onLoad={this.iframeLoad}
          ></iframe>
        </div>
      </Fragment>
    );
  }
}

export default DashBoard;
